/* Fix: restore transparent header (is-light) after a drawer closes
   while the user is still in the overlay/hero zone. */
(function () {
  var WRAPPER_ID = 'HeaderWrapper';
  var HEADER_ID  = 'SiteHeader';
  var OVERLAYED  = 'is-light';
  var SCROLL_THRESHOLD = 250; // matches scrollHandler's threshold in theme.js

  var html    = document.documentElement;
  var wrapper = document.getElementById(WRAPPER_ID);
  var header  = document.getElementById(HEADER_ID);
  if (!wrapper || !header) return;

  // Only act on pages where the header is configured as a transparent overlay
  var isOverlayHeader = header.dataset.overlay === 'true';
  if (!isOverlayHeader) return;

  var wasOverlayedBeforeDrawer = wrapper.classList.contains(OVERLAYED);
  var drawerWasOpen = false;

  // Track whether a drawer is currently open (cart, nav, search — all use js-drawer-open)
  var observer = new MutationObserver(function () {
    var isOpen = html.classList.contains('js-drawer-open');
    var isClosing = html.classList.contains('js-drawer-closing');

    if (isOpen && !drawerWasOpen) {
      // Drawer just opened — remember state we should restore to
      wasOverlayedBeforeDrawer = wrapper.classList.contains(OVERLAYED);
      drawerWasOpen = true;
    } else if (!isOpen && !isClosing && drawerWasOpen) {
      // Drawer fully closed — restore is-light if we were in the overlay zone
      drawerWasOpen = false;
      if (wasOverlayedBeforeDrawer && window.scrollY <= SCROLL_THRESHOLD) {
        wrapper.classList.add(OVERLAYED);
      }
    }
  });

  observer.observe(html, { attributes: true, attributeFilter: ['class'] });
})();


/* ============================================================
   Mega menu hover persistence
   Keeps the mega menu open while the cursor is anywhere inside
   the header (logo, currency switcher, account, cart, etc.)

   Why: the theme's hoverMenu in theme.js attaches a mouseleave
   listener directly to each <details data-hover="true">. As soon
   as the cursor leaves the <details>, the menu closes — even
   when the cursor is moving to another element inside the header.

   Fix:
   1. Capture-phase mouseleave on each <details> that suppresses
      the theme's close handler when the cursor is still inside
      the header.
   2. A single mouseleave on the header itself that closes any
      open menu when the cursor genuinely leaves the header.
   3. Mouseover on each <details> that closes the others, since
      step 1 removed the auto-close on leave.
   ============================================================ */
(function () {
  function init() {
    var header = document.getElementById('SiteHeader');
    if (!header || header.dataset.megaFixApplied) return;
    header.dataset.megaFixApplied = '1';

    var detailsList = header.querySelectorAll('details[data-hover="true"]');
    if (!detailsList.length) return;

    // 1. Suppress per-<details> mouseleave when cursor is still inside the header.
    detailsList.forEach(function (detail) {
      detail.addEventListener('mouseleave', function (e) {
        var to = e.relatedTarget;
        if (to && header.contains(to)) {
          e.stopImmediatePropagation();
        }
      }, true); // capture phase — runs before the theme's listener
    });

    // 2. Close any open mega menu when the cursor truly leaves the header.
    header.addEventListener('mouseleave', function (e) {
      var to = e.relatedTarget;
      if (to && header.contains(to)) return;
      detailsList.forEach(function (d) {
        if (d.hasAttribute('open') && !d.matches(':focus-within')) {
          d.removeAttribute('open');
          d.setAttribute('aria-expanded', 'false');
        }
      });
    });

    // 3. When hovering a different nav item, close the others.
    detailsList.forEach(function (detail) {
      detail.addEventListener('mouseover', function () {
        detailsList.forEach(function (other) {
          if (other !== detail && other.hasAttribute('open')) {
            other.removeAttribute('open');
            other.setAttribute('aria-expanded', 'false');
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();